import styled from 'styled-components';
import { COLORS } from '../../../game/data/colors';

export const GreenButton = styled.button<{ disabled?: boolean }>(({ disabled = false }) => ({
  textAlign: 'center',
  border: 'none',
  margin: 0,
  backgroundColor: !disabled ? COLORS.green_500 : COLORS.zinc_400,
  color: 'white',
  borderRadius: 4,
  padding: '4px 8px',
  fontWeight: 600,
  fontSize: '1rem',
  cursor: !disabled ? 'pointer' : 'default',
  borderBottom: `4px solid ${!disabled ? COLORS.green_700 : COLORS.zinc_600}`,
  ...(!disabled && {
    '&:hover': {
      backgroundColor: COLORS.green_600,
    },
    '&:active': {
      backgroundColor: COLORS.green_700,
      borderTop: `4px solid ${COLORS.zinc_800}`, // this only works if the background has zinc_800 color
      borderBottom: 'none',
      borderRadius: '6px 6px 4px 4px',
    },
  }),
}));

export const YellowButton = styled.button<{ disabled?: boolean }>(({ disabled = false }) => ({
  textAlign: 'center',
  border: 'none',
  margin: 0,
  backgroundColor: !disabled ? COLORS.yellow_500 : COLORS.zinc_400,
  color: 'white',
  borderRadius: 4,
  padding: 4,
  fontWeight: 600,
  fontSize: '1.2rem',
  cursor: !disabled ? 'pointer' : 'default',
  borderBottom: `4px solid ${!disabled ? COLORS.yellow_700 : COLORS.zinc_600}`,
  ...(!disabled && {
    '&:hover': {
      backgroundColor: COLORS.yellow_600,
    },
    '&:active': {
      backgroundColor: COLORS.yellow_700,
      borderTop: `4px solid ${COLORS.zinc_800}`, // this only works if the background has zinc_800 color
      borderBottom: 'none',
      borderRadius: '6px 6px 4px 4px',
    },
  }),
}));
